import momentCN from 'moment/locale/zh-cn'

const components = {
  momentName: 'zh-cn',
  momentLocale: momentCN
}

const locale = {
  'message': '-',
  'layouts.EmailMarketing': '邮件营销',
  'layouts.riseSuddenlyAndSharply': '引爆增长',
  'layouts.应用市场': '应用市场',
  'layouts.易学堂（直播/回放）': '易学堂（直播/回放）',
  'layouts.直播/回放': '直播/回放',
  'layouts.本服务适合': '本服务适合拥有ebay或独立站的卖家',
  'layouts.可打通多平台数据': '可打通多平台数据进行用户分群，通过邮件方式对私域流量进行精准营销，ROI最高可达',
  'layouts.application': '应用',
  'layouts.current': '正在使用',
  'layouts.去开通': '去开通',
  'layouts.已开通系统': '已开通系统',
  'layouts.推荐开通系统': '推荐开通系统',
  'layouts.可选择切换导航菜单': '可选择切换导航菜单',
  'layouts.switch': '切换{0}',
  'layouts.change': '菜单置于{0}',
  'layouts.new.version': '新版',
  'layouts.new': '新增',
  'layouts.edit': '编辑',
  'layouts.show': '显示{0}',
  'layouts.hide': '隐藏{0}',
  'layouts.paidPage': '付费页面',
  'layouts.expired': '过期',
  'layouts.upgrade': '升级',
  'layouts.buy': '购买',
  'layouts.onlineservice': '人工客服',
  'layouts.exportcenter': '导出中心',
  'layouts.exportcenterhere': '导出中心在这里！',
  'layouts.MoneyAssistant': '资金助手',
  'layouts.accountSettings': '账号设置',
  'layouts.usercenter': '用户中心',
  'layouts.productPackage': '产品套餐',
  'layouts.authority': '权限管理',
  'layouts.store.authorization': '店铺授权',
  'layouts.helpcenter': '帮助中心',
  'layouts.menusyl': '菜单样式',
  'layouts.menusyl.top': '顶部菜单布局',
  'layouts.menusyl.left': '侧边菜单布局',
  'layouts.langset': '语言设置',
  'layouts.menutransformation': '全部菜单',
  'layouts.logout': '退出系统',
  'layouts.allapplication': '全部应用',
  'layouts.history': '最近打开',
  'layouts.maylike': '猜您想搜，可能是菜单搬家以后的名称',
  'layouts.customscene': '{0}自定义场景',
  'layouts.demo.tips': 'DEMO环境不支持该操作，您可以使用自有账号操作该功能',
  'layouts.customscene.currentNoDel': '正在使用的场景不允许删除，请先切换到其他场景再进行删除',
  'layouts.allmenu': '全部菜单',
  'layouts.menusearch': '请输入关键词，搜索菜单',
  'layouts.commonmenu': '常用菜单',
  'layouts.search.placeholder': '请输入关键词，搜索菜单',
  'layouts.text.undefined': '暂无数据',
  'layouts.operation.guide': '操作指南',
  'layouts.bookmarks': '常用功能收藏夹',
  'layouts.bookmarks.success': '添加收藏成功',
  'layouts.bookmarks.cancel': '取消收藏成功',
  'layouts.openAll': '一键全开',
  'layouts.manageFavorites': '管理收藏夹',
  'layouts.ViewAll': '查看全部功能',
  'layout.searchKeyword': '搜索关键词',
  'layout.error-401': '抱歉，您还未开通该功能权限，请联系系统管理员账号持有人，帮助您开通菜单权限。',

  'layout.guideLayout.title': '一键绑定店铺，立即开启您的跨境业务！',
  'layout.guideLayout.step1': '第一步，绑定您的店铺',
  'layout.guideLayout.p1': '绑定店铺后，我们将会立即开始同步您店铺的商品与订单，便于您进入系统后立即能够开展业务！',
  'layout.guideLayout.p2': '新手引导仅为您能快速开展业务，进入系统后，您依然可以绑定其他店铺。',
  'layout.guideLayout.amazon.title': '7日内绑定店铺，即送2000单',
  'layout.guideLayout.amazon.click': '点击绑定您的亚马逊店铺',
  'layout.guideLayout.shopify.click': '点击绑定您的Shopify店铺',
  'layout.guideLayout.temu.click': '点击绑定您的TEMU店铺',
  'layout.guideLayout.tiktok.click': '点击绑定您的Tiktok店铺',
  'layout.guideLayout.morePlatform': '更多平台 敬请期待....',
  'layout.guideLayout.p3': '点击',
  'layout.guideLayout.p4': '此处',
  'layout.guideLayout.p5': '进入演示环境，提前体验完整功能！',
  'layout.guideLayout.店铺授权': '店铺授权',
  'layout.guideLayout.bindSuccess': '绑定成功',
  'layout.guideLayout.waitText1': '进入账户后，我们将开始同步您的商品与订单数据。',
  'layout.guideLayout.waitText2': '预计耗时 5–30 分钟，请耐心等待。',
  'layout.guideLayout.btnBindMore': '绑定更多店铺',
  'layout.guideLayout.linkJump': '立即进入',

  'version-modal.title': '切换须知',
  'version-modal.tips': '此次切换将不可退回至现有版本，你还可以通过查看新版介绍进行全面的了解',
  'version-modal.info': '切换到轻易ERP之后，将会有以下变化:',
  'version-modal.subInfo-1': '系统Ul的改变',
  'version-modal.subInfo-2': '菜单顺序的改变',
  'version-modal.subInfo-3': '功能可能会相应删减和增加，但不会影响基本的业务流程',
  'version-modal.footer': '我已经了解上述情况，同意切换。',
  'version-modal.viewDemo': '查看Demo',

  'store-tip.title': '出海利器 大卖必备',
  'store-tip.subtitle': '2分钟快速授权',
  'store-tip.guide': '科技赋能 开启精益运营之门',
  'store-tip.info-1': '多店铺管理<br>安全防关联',
  'store-tip.info-2': '实时数据同步<br>安全可靠',
  'store-tip.info-3': '运营风险<br>及时提醒',
  'store-tip.remind': '本次登录不再提醒',
  'store-tip.btn': '店铺授权',

  'form-modal.cancel': '取消',
  'form-modal.submit': '确认',
  'form-modal.delete': '删除',
  'form-modal.selected': '已选中',
  'form-modal.action': '个操作',
  'form-modal.third-party-abnormal': '第三方系统异常！',
  'form-modal.custom.title': '自定义场景面板',
  'form-modal.customMenuName': '场景名称',
  'form-modal.system.title': '自定义应用菜单',
  'form-modal.menuname.placeholder': '请输入自定义场景名称',
  'form-modal.remark.placeholder': '备注',
  'form-modal.rule.maxstring': '最多支持{0}个字符串',
  'form-modal.rule.maxobject': '最多选择{0}项',
  'form-modal.rule.select': '请选择{0}',
  'notification-modal.title.prompt': '温馨提示',
  'notification-modal.content.delete.customscene': '是否确定删除该场景，该操作不可恢复',
  'notification-modal.content.maxcustomscene': '最多可创建30个场景，您可以删除废弃的场景或编辑现有场景',
  'logout.title': '退出确认',
  'logout.content': '确定退出登录吗？',
  'logout.okText': '确认',
  'logout.cancelText': '取消',
  'tabs.close.current': '关闭当前标签',
  'tabs.close.right': '关闭右侧',
  'tabs.close.left': '关闭左侧',
  'tabs.close.all': '关闭全部',

  'station.免费快速建站': '免费快速建站',
  'station.专属品牌': '专属品牌独立站',
  'station.多渠道': '多渠道低价引流',
  'station.品牌用户': '品牌用户沉淀',
  'station.精细化运营': '精细化运营',
  'station.用户裂变': '用户裂变增长',
  'station.获取利润': '获取利润最大化',
  'station.一键建站': '一键建站',

  'station.请填写建站信息': '请填写建站信息',
  'station.您的建站信息已提交': '您的建站信息已提交',
  'station.我们正在加班加点搭建中': '我们正在加班加点搭建中',
  'station.预计3个工作日内主动联系您': '预计3个工作日内主动联系您',
  'station.您也可以通过扫描二维码': '您也可以通过扫描二维码联系我们优先建站',
  'station.我知道了': '我知道了',
  'station.请填写正确的手机号': '请填写正确的手机号',
  'station.请填写正确的邮箱': '请填写正确的邮箱',
  'station.请填写正确的姓名': '请填写正确的姓名',
  'station.请使用已授权亚马逊店铺的账号创建独立站': '请使用已授权亚马逊店铺的账号创建独立站',
  'station.请同意使用刊登系统搭建独立站': '请同意使用刊登系统搭建独立站',
  'station.请选择一个店铺': '请选择一个店铺创建独立站',
  'station.目前暂时只支持': '目前暂时只支持亚马逊店铺免费建站',
  'station.邮箱': '邮箱',
  'station.联系人姓名': '联系人姓名',
  'station.信息填写无误': '信息填写无误，免费建站',
  'station.同意使用刊登系统': '同意使用刊登系统搭建独立站',
  'station.为了能更快帮助您创建独立站': '为了能更快帮助您创建独立站，我们需要用到刊登系统：若您已购买刊登系统（旧版），我们将直接使用系统帮助您刊登商品；若您还未购买刊登系统（旧版），我们将为您免费开通14天刊登系统套餐。(系统地址：https://adv-listing.eccang.com/default/index/login)',

  'EDM.邮件营销': '邮件营销',
  'EDM.智能分群': '智能分群推荐',
  'EDM.大数据挖掘': '大数据挖掘',
  'EDM.千万级发送量': '千万级发送量',
  'EDM.自动化埋点': '自动化埋点',
  'EDM.快捷邮件制作': '快捷邮件制作',
  'EDM.自动营销风控': '自动营销风控',
  'EDM.立即体验': '立即体验',

  'empty_data': '当前暂无未读消息',
  'authority_account_edit_password': '修改密码',
  'common_globalcomp_login_again': '重新登录'

}

export default {
  ...components,
  ...locale
}
